import { render, staticRenderFns } from "./TrainZCS.vue?vue&type=template&id=b1bed2bc&"
import script from "./TrainZCS.vue?vue&type=script&lang=js&"
export * from "./TrainZCS.vue?vue&type=script&lang=js&"
import style0 from "./TrainZCS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports